import { Grid2, Typography } from '@mui/material';
import Block from '../../../../components/Block';
import Column from '../../../../components/Column';
import Row from '../../../../components/Row';
import { HatDbVisualPerformanceLineChartCard } from '../widgets/HatDbVisualPerformanceLineChartCard';
import { attributionExplainTooltip } from '../../HatDashboardPage';
import HatDbSectionActionAttribution from './HatDbSectionActionAttribution';
import HatDbSectionChannelAttribution from './HatDbSectionChannelAttribution';
import HatDbVisualComputedMetricCard from '../widgets/HatDbVisualComputedMetricCard';
import { hatMetrics } from '../../HatMetrics';
import { ReactNode } from 'react';

export function Hat2DbContentSection(props: { exportHeader?: ReactNode }) {
    return (
        <>
            <Block data-pdf-page>
                {props.exportHeader}

                <Column>
                    <Row flex={1} width="100%">
                        <Typography variant="h6">Performance</Typography>
                    </Row>

                    <Grid2 container spacing={2}>
                        <Grid2 size={{ sm: 12, md: 6, lg: 3 }}>
                            <HatDbVisualComputedMetricCard
                                hatMetric={hatMetrics.totalVisits}
                                label="Total Visits"
                                dataContextKey="totalVisits"
                            />
                        </Grid2>

                        <Grid2 size={{ sm: 12, md: 6, lg: 3 }}>
                            <HatDbVisualComputedMetricCard
                                hatMetric={hatMetrics.totalAdInfluencedVisits}
                                label="Attributed Visits"
                                tooltip={attributionExplainTooltip}
                                dataContextKey="attributedVisits"
                            />
                        </Grid2>

                        <Grid2 size={{ sm: 12, md: 6, lg: 3 }}>
                            <HatDbVisualComputedMetricCard
                                hatMetric={hatMetrics.totalActions}
                                label="Total Actions"
                                dataContextKey="totalActions"
                            />
                        </Grid2>

                        <Grid2 size={{ sm: 12, md: 6, lg: 3 }}>
                            <HatDbVisualComputedMetricCard
                                hatMetric={hatMetrics.totalAdInfluencedActions}
                                label="Attributed Actions"
                                tooltip={attributionExplainTooltip}
                                dataContextKey="attributedActions"
                            />
                        </Grid2>
                    </Grid2>

                    <HatDbVisualPerformanceLineChartCard />
                </Column>
            </Block>

            <Block data-pdf-page>
                <Column>
                    <Typography variant="h6">Visits</Typography>

                    <HatDbSectionChannelAttribution dataContextKey="channelAttribution" />
                </Column>
            </Block>

            <Block data-pdf-page>
                <Column>
                    <Typography variant="h6">Actions</Typography>

                    <HatDbSectionActionAttribution dataContextKey="actionAttribution" />
                </Column>
            </Block>
        </>
    );
}
